import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { finalize, Observable, tap } from 'rxjs';

import { NavigationReadsService } from './navigation-reads.service';

@Injectable()
export class NavigationReadsInterceptor implements HttpInterceptor {
  constructor(private reads: NavigationReadsService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    if (
      ['GET', 'HEAD', 'OPTIONS'].includes(request.method) ||
      !request.url.includes('/api/')
    )
      return next.handle(request);
    this.reads.invalidate();
    let settled = false;
    return next.handle(request).pipe(
      tap({
        next: (event) => {
          if (event instanceof HttpResponse) {
            // Invalidate before the caller starts a refresh/navigation from its success callback.
            settled = true;
            this.reads.invalidate();
          }
        },
        error: () => {
          settled = true;
          this.reads.invalidate();
        },
      }),
      // Cancellation leaves the operation's outcome unknown, too.
      finalize(() => {
        if (!settled) this.reads.invalidate();
      }),
    );
  }
}
